__turbopack_context__.v({
  "Icon": "FontAwesomeIcon-module-scss-module__hqSTAG__Icon",
});
